import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const FeedbackLoop = () => {
  const [activePoll, setActivePoll] = useState(null);
  const [voted, setVoted] = useState(false);

  const options = [
    { id: 1, label: "Marketing Operations Redundancy", votes: "42%" },
    { id: 2, label: "AI Integration Friction", votes: "35%" },
    { id: 3, label: "Brand-Performance Disconnect", votes: "23%" }
  ];

  const handleVote = (id) => {
    setActivePoll(id);
    setVoted(true);
  };

  return (
    <section className="py-24 bg-slate-50 dark:bg-brand-dark">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-white dark:bg-slate-900 rounded-3xl p-6 md:p-16 shadow-2xl border border-slate-100 dark:border-slate-800 relative overflow-hidden">
          <div className="absolute top-0 right-0 p-8 opacity-5">
            <SafeIcon name="Share2" className="w-32 h-32 text-brand-cyan" />
          </div>
          
          <div className="relative z-10">
            <span className="text-brand-red dark:text-brand-yellow text-xs uppercase tracking-[0.3em] font-bold block mb-4">Strategic Pulse</span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-slate-900 dark:text-white mb-6">Interactive Feedback Loop</h2>
            <p className="text-slate-600 dark:text-slate-400 text-lg font-medium mb-12 max-w-2xl">
              What is the single biggest operational hurdle your marketing organization is facing this quarter? Participate in our live strategic audit.
            </p>

            <div className="space-y-4">
              {options.map((opt) => (
                <button
                  key={opt.id}
                  onClick={() => handleVote(opt.id)}
                  className={`w-full text-left p-6 rounded-xl border-2 transition-all flex items-center justify-between group ${
                    activePoll === opt.id
                    ? 'border-brand-red dark:border-brand-cyan bg-brand-red/5 dark:bg-brand-cyan/5'
                    : 'border-slate-100 dark:border-slate-800 hover:border-brand-red dark:hover:border-brand-cyan hover:bg-slate-50 dark:hover:bg-slate-800/50'
                  }`}
                >
                  <div className="flex items-center gap-4">
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${activePoll === opt.id ? 'border-brand-red dark:border-brand-cyan bg-brand-red dark:bg-brand-cyan' : 'border-slate-300'}`}>
                      {activePoll === opt.id && <SafeIcon name="Check" className="w-3 h-3 text-white dark:text-brand-dark" />}
                    </div>
                    <span className="font-bold text-slate-800 dark:text-slate-200">{opt.label}</span>
                  </div>
                  {voted && <span className="text-brand-red dark:text-brand-cyan font-black">{opt.votes}</span>}
                </button>
              ))}
            </div>

            {voted && (
              <motion.div
                initial={{ opacity: 0, y: 10 }} 
                animate={{ opacity: 1, y: 0 }}
                className="mt-8 space-y-4"
              >
                <p className="text-sm font-bold text-brand-red dark:text-brand-cyan flex items-center gap-2">
                  <SafeIcon name="Info" className="w-4 h-4" /> Your insight has been added to our quarterly Strategic Briefing.
                </p>
                <Link to="/portal" className="inline-flex items-center gap-2 text-xs uppercase font-bold tracking-widest text-brand-red dark:text-brand-cyan hover:opacity-80 transition-colors">
                  View Client Portal <SafeIcon name="ArrowRight" className="w-4 h-4" />
                </Link>
              </motion.div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeedbackLoop;